module.exports = __webpack_public_path__ + "static/media/banner.1715af89.jpg";